<template>
  <popup ref="popup" :show="show" :title="title" class-name="cascade-popup" @close="close">
    <rich-loading v-show="loading" class="loading"></rich-loading>
    <div class="cascade-bread-crumbs">
      <span class="bread-crumbs-all-span" @click="handleAll">All</span>
      <div v-for="(item, index) in breadCrumbList" :key="index" class="bread-crumbs-list">
        <i class="bread-crumbs-dividing">/</i>
        <span class="bread-crumbs-span" @click="handleCrumbList(item, index)">{{ item }}</span>
      </div>
    </div>
    <div class="cascade-wrapper">
      <div v-if="!breadCrumbList.length" class="cascade-select-wrapper">
        <cascade-item
          v-for="(item, index) in options"
          :key="index"
          :options="options"
          :cascade-item="item"
          :checkboxs="checkboxs"
          :cascade-index="index"
          @showTreeList="treeList"
          @checkboxNums="checkboxNums"
        />
      </div>
      <div v-else class="cascade-select-wrapper">
        <cascade-item
          v-for="(item, index) in optionList"
          :key="index"
          :options="options"
          :checkboxs="checkboxs"
          :cascade-item="item"
          :cascade-index="index"
          @showTreeList="treeList"
          @checkboxNums="checkboxNums"
        />
      </div>
    </div>

    <div slot="footer" slot-scope="props" class="buttons-wrapper">
      <div class="button button-reset" @touchstart.prevent="reset(props)">
        {{ $t('FoodOpB_Gattaran_Reset_ILVf' /**重置 */) }}
      </div>
      <div class="button button-submit" @touchstart.prevent="submit(props)">
        {{ gettext('提交') }}({{ salesNameNum }})
      </div>
    </div>
  </popup>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import popup from '../index.vue'
import cascadeItem from './cascadeItem.vue'
const namespace = 'bizopp'
export default {
  components: {
    popup,
    cascadeItem,
  },
  provide() {
    return {}
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      /** [{
       * label: "", //组名
       * key: "组唯一值",
       * options: [{
       *    label: "", //值名
       *    value: "" //值
       * }]
      }] */
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: true,
    },
    paramKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checked: {},
      optionList: [],
      checkboxs: [],
      checkboxNum: 0,
    }
  },
  computed: {
    ...mapState(namespace, {
      salesNameNum: state => state.salesNameNum,
      breadCrumbList: state => state.breadCrumbList,
    }),
  },
  watch: {
    salesNameNum(nVal) {
      if (nVal > 99) {
        this.updateSalesNameNum(99 + '+')
      }
    },
    options(nVal) {
      if (this.breadCrumbList.length) {
        this.optionInit(nVal, this.breadCrumbList[this.breadCrumbList.length - 1])
      }
    },
  },
  methods: {
    ...mapMutations(namespace, [
      'updateSalesNameNum', // 更新销售姓名数量
      'updateBreadCrumbList',
      'updateBreadCrumbChange',
    ]),
    close() {
      this.$emit('close')
    },
    reset(props) {
      this.checkboxs = []
      this.checkboxNum = 0
      this.handleAll()
      this.$emit('submit', this.checkboxs)
      this.updateSalesNameNum(0)
      props.close()
    },
    submit(props) {
      this.$emit('submit', this.checkboxs)
      props.close()
    },
    treeList() {
      this.optionList = this.options
      if (this.breadCrumbList) {
        this.breadCrumbList.forEach(item => {
          this.optionList = this.optionTree(item)
        })
      }
    },
    checkboxNums(num) {
      if (num.length >= 99) {
        this.checkboxNum = 99 + '+'
      }
      this.checkboxs = num
      this.checkboxNum = num.length
    },
    handleAll() {
      this.updateBreadCrumbList()
    },
    handleCrumbList(value, index) {
      if (index !== this.breadCrumbList.length - 1) {
        this.updateBreadCrumbChange({ value, index })
        this.optionInit(this.options, value)
      }
    },
    optionInit(data, value) {
      data.forEach(item => {
        if (item.username === value) {
          this.optionList = item.children
        } else if (item.children) {
          this.optionInit(item.children, value)
        }
      })
    },
    optionTree(value) {
      let treeList = []
      this.optionList.forEach(opItem => {
        if (opItem.username === value) {
          treeList = opItem.children
        }
      })
      return treeList
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .content-slot {
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
}

.multiple-select-wrapper {
  padding-top: 32px;
}

.loading {
  position: absolute;
  left: 50%;
  margin-left: -11px;
}

.cascade-bread-crumbs {
  font-family: DiDiSans-Pro-Regular;
  font-size: 36px;
  padding: 40px 0;
  font-weight: normal;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  &::-webkit-scrollbar {
    display: none;
  }
  .bread-crumbs-all-span {
    min-width: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    color: #fc7633;
    height: 26px;
    line-height: 26px;
  }
  .bread-crumbs-span {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    color: #fc7633;
  }
  .bread-crumbs-list {
    display: flex;
    align-items: center;
    height: 26px;
    line-height: 26px;
    .bread-crumbs-dividing {
      margin: 0 12px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #8d9099;
      text-align: center;
      font-weight: normal;
    }
  }
}

.cascade-wrapper {
  flex: 1;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}

::v-deep .rich-checkbox-text {
  font-family: DiDiSans-Pro-Regular;
  font-size: 36px !important;
  color: #282b33;
  line-height: 44px;
  font-weight: normal;
}

::v-deep .popup-content {
  height: 1250px;
}
::v-deep .content-slot {
  max-height: 100% !important;
}
::v-deep .popup-wrapper .popup-content .content-header[data-v-c74a8dbc] {
  height: 112px;
}
.buttons-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 24px 24px 37px;

  .button {
    position: relative;
    z-index: 2;
    margin-right: 24px;
    flex: 1;
    border-radius: 28px;
    height: 92px;
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    text-align: center;
    line-height: 92px;
    font-weight: 500;

    &:nth-child(2n) {
      margin-right: 0;
    }

    &.button-reset {
      background: #fff7f2;
      // border: 1px solid #f76a31;
      color: #f76a31;
    }

    &.button-submit {
      background: #ff7a45;
      color: #ffffff;
    }
  }
}
</style>
